import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import {
  SETTINGS_ACTIVITY_NAME_FIELD,
  SETTINGS_ACTIVITY_DESCRIPTION_FIELD
} from '../../actions/types';

import TableConfirmation from '../tables-manager/shared/TableConfirmation';

import '../tables-manager/table-base/TableColumnsActions.scss';
import './SettingsActionCell.scss';

const ActivityActionCell = ({
  row,
  column,
  updateDataFromCell,
  deleteItem,
  updateItem
}) => {
  const actionsRef = useRef(null);
  const [open, setOpen] = useState(false);

  const deleteRef = useRef(null);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (deleteRef.current && !deleteRef.current.contains(e.target)) {
        setShowDelete(false);
      }
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setShowDelete(false);
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const [editing, setEditing] = useState(false);

  const handleEditItem = useCallback(() => {
    row.setState((s) => ({ ...s, editing: true }));
    setEditing(true);
    setOpen(false);
  }, []);

  const handleCancel = useCallback(() => {
    updateDataFromCell(row.index, column.id, {
      [SETTINGS_ACTIVITY_NAME_FIELD]: row.state[SETTINGS_ACTIVITY_NAME_FIELD],
      [SETTINGS_ACTIVITY_DESCRIPTION_FIELD]: row.state[SETTINGS_ACTIVITY_DESCRIPTION_FIELD]
    });

    row.setState((s) => ({ ...s, editing: false }));
    setEditing(false);
  }, [row.state, row.index, column.id]);

  const handleUpdateItem = useCallback(async () => {
    const data = {
      [SETTINGS_ACTIVITY_NAME_FIELD]: row.original[SETTINGS_ACTIVITY_NAME_FIELD],
      [SETTINGS_ACTIVITY_DESCRIPTION_FIELD]: row.original[SETTINGS_ACTIVITY_DESCRIPTION_FIELD]
    };

    if (!data[SETTINGS_ACTIVITY_NAME_FIELD]) {
      return toast.error('Activity name is required', {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }

    const res = await updateItem(row.original._id, data);

    if (res) {
      updateDataFromCell(row.index, column.id, res);
      row.setState((s) => ({ ...s, ...res, editing: false }));
      setEditing(false);
    } else {
      updateDataFromCell(row.index, column.id, {
        [SETTINGS_ACTIVITY_NAME_FIELD]: row.state[SETTINGS_ACTIVITY_NAME_FIELD],
        [SETTINGS_ACTIVITY_DESCRIPTION_FIELD]: row.state[SETTINGS_ACTIVITY_DESCRIPTION_FIELD]
      });
    }
  }, [row, column.id]);

  return (
    <>
      {editing ? (
        <div className="table-columns-action-editing-box">
          <div className="editing-cancel" onClick={handleCancel}><i className="fas fa-times" /></div>
          <div className="editing-update" onClick={handleUpdateItem}><i className="fas fa-check" /></div>
        </div>
      ) : (
        <div className="table-columns-action-box action-editing-box">
          <div onClick={() => setOpen((s) => !s)} className="table-action-trigger">
            <img style={{ height: 21, width: 21 }} src={require('../../assets/images/icons/kebab_menu.svg')} alt="" />
            <img style={{ height: 21, width: 21 }} className="img-active" src={require('../../assets/images/icons/kebab_menu_o.svg')} alt="" />
          </div>

          {open && (
            <div ref={actionsRef} className="table-actions-box">
              <div className="table-action-trigger the-action" onClick={handleEditItem}>
                <img src={require('../../assets/images/icons/ico_edit.svg')} alt="" />
                <img className="img-active" src={require('../../assets/images/icons/ico_edit_o.svg')} alt="" />
                <span>Edit</span>
              </div>

              <div ref={deleteRef} className="table-action-trigger the-action">
                <img onClick={() => setShowDelete((s) => !s)} src={require('../../assets/images/icons/ico_delete.svg')} alt="" />
                <img onClick={() => setShowDelete((s) => !s)} className="img-active" src={require('../../assets/images/icons/ico_delete_o.svg')} alt="" />
                <span onClick={() => setShowDelete((s) => !s)}>Delete</span>

                {showDelete && (
                  <TableConfirmation
                    withoutDispatch={true}
                    onSubmit={deleteItem}
                    onDelete={() => {
                      setOpen(false);
                      setShowDelete(false);
                    }}
                    handleCancel={() => setShowDelete(false)}
                    title="Are you sure to deactivate?"
                    data={row.original._id}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

ActivityActionCell.propTypes = {
  row: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  updateDataFromCell: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired
};

export default ActivityActionCell;
